import { Link, Ta11yText } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appLinkSize, appLinkStyle } from '@utils/globalConstant';
import React from 'react';

export const CMSLink = ({
  className,
  linkKey,
  ...rest
}) => {
  
  // const
  const linkContent = tA11y(linkKey);

  if (!linkContent || !linkContent.content) {
    return null;
  }

  return linkContent?.type === "link" ? (
    <Link
      label={linkKey}
      linkStyle={`${appLinkStyle.PRIMARY} ${className}`}
      linkSize={appLinkSize.DEFAULT}
      href={linkContent.url}
      {...rest}
    />
  ) :
    <Ta11yText
      tag={"p"}
      textContent={linkContent}
      className={""}
    />
};

export default CMSLink;
